import {Component, OnInit, inject} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {TranslationService} from '../../../core/services/translation.service';
import {RevocationService} from '../../../data/services/revocation.service';
import {HupSubscriptionsService} from '../../../data/services/hup-subscriptions.service';
import {HupSubscription} from '../../../data/models/subscription.model';
import {NavigationCommand, NavigationService} from '../../../data/services/navigation.service';
import {SnackbarService} from "../../../core/services/snackbar.service";
import {UserData} from "../../../data/models/user-data.model";
import {LoginService} from "../../../core/components/login/login.service";

@Component({
  selector: 'app-revocation-edit',
  templateUrl: './revocation-edit.component.html',
  styleUrls: ['./revocation-edit.component.scss']
})
export class RevocationEditComponent implements OnInit {
  private revocationService = inject(RevocationService);
  private hupSubscriptionsService = inject(HupSubscriptionsService);
  private navigationService = inject(NavigationService);
  private route = inject(ActivatedRoute);
  private formBuilder = inject(FormBuilder);
  translationService = inject(TranslationService);
  private snackbarService = inject(SnackbarService);
  private loginService = inject(LoginService);

  isLoading = false;
  subscription: HupSubscription | null = null;
  private user: UserData | null = null;
  errorsArr: string[] = [];

  confirmForm: FormGroup = this.formBuilder.group({
    confirmed: [false, Validators.requiredTrue]
  });

  ngOnInit(): void {
    const webId = this.route.snapshot.paramMap.get('webId');
    const backendId = this.route.snapshot.paramMap.get('backendId');
    if (webId && backendId) {
      this.isLoading = true;
      this.hupSubscriptionsService.getSubscription(webId, backendId).subscribe({
        next: sub => {
          this.subscription = sub;

          if (this.subscription && this.subscription.userBackendId > 0) {
            this.loginService.getUserData().subscribe({
              next: user => {
                this.isLoading = false;
                this.user = user;
              },
              error: () => {
                this.isLoading = false;
              }
            });
          }
        },
        error: () => {
          this.isLoading = false;
          this.errorsArr.push(this.translationService.getTranslation('error_subscription_init'));
        }
      });
    }
  }

  onSubmit(): void {
    if (this.confirmForm.invalid) {
      this.confirmForm.markAllAsTouched();
      return;
    }
    if (!this.subscription) {
      return;
    }
    this.isLoading = true;
    this.errorsArr = [];
    this.revocationService.sendRevocation({
      orderNo: this.subscription.webId > 0 ? this.subscription.webId : this.subscription.backendId,
      idType: this.subscription.webId > 0 ? 'WEBID' : 'ORDERNO',
      firstName: this.user?.person?.firstname ?? '',
      lastName: this.user?.person?.lastname ?? '',
      email: this.user?.emailList[0] ?? ''
    }).subscribe({
      next: () => {
        this.isLoading = false;
        this.revocationService.resetData();
        this.snackbarService.openSnackbar(this.translationService.getTranslation('revocation_saved'));
        this.navigationService.navigateTo(NavigationCommand.REVOCATION);
      },
      error: err => {
        this.isLoading = false;
        if (err?.status === 409) {
          this.errorsArr.push(this.translationService.getTranslation('revocation_already_exists'));
        } else if (err?.status === 422) {
          this.errorsArr.push(this.translationService.getTranslation('revocation_window_expired'));
        } else {
          this.errorsArr.push(this.translationService.getTranslation('error_general'));
        }
      }
    });
  }

  onCancel(): void {
    this.navigationService.navigateTo(NavigationCommand.REVOCATION);
  }
}
